import cn from "classnames";
import styles from "./Photo.module.scss";

const Photo = ({ className, src, alt }: {
  className?: string;
  src: string;
  alt?: string;
}) => {

  return (
    <img
      className={cn(styles.photo, className)}
      src={src}
      alt={alt}
    />
  );
};

export default Photo;
